import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import * as StringUtils from 'web-app/util/string';

export default class ChildApi {
    static checkin(childId, pickupTime, pickupRelationId, goHomeWithChildId, groupId) {
        return RESTClient.postAuthenticated(`v2/children/${childId}/checkins`, {
            groupId,
            pickupTime,
            pickupRelationId,
            goHomeWithChildId,
        });
    }

    static checkout(childId) {
        return RESTClient.postAuthenticated(`v2/children/${childId}/checkout`);
    }

    static registerAction(childId, actionType, payload) {
        return RESTClient.postAuthenticated('v2/actions', {
            recipient: StringUtils.fromChildIdToRecipient(childId),
            actionType,
            payload,
        });
    }

    static deleteAction(actionId) {
        return RESTClient.deleteAuthenticated(`v2/actions/${actionId}`);
    }

    static deleteLeave(childLeaveId) {
        return RESTClient.deleteAuthenticated(`v2/childleaves/${childLeaveId}`);
    }

    static fetchSummary(childId) {
        return RESTClient.getAuthenticated(`v2/children/${childId}/summary`);
    }

    static changeStartAndEndDates(childId, startDate, endDate, leavingReason) {
        return RESTClient.postAuthenticatedObservable(`v2/children/${childId}`, {
            startDate,
            endDate,
            leavingReason,
        });
    }

    static getPlannedCheckout(childId, planId) {
        return RESTClient.getAuthenticated(`v2/children/${childId}/plannedCheckout/${planId}`);
    }

    static createPlannedCheckout({childId, startDate, endDate, title, recurringWeekly, checkoutType}) {
        return RESTClient.postAuthenticated(`v2/children/${childId}/plannedCheckout`, {
            startDate,
            endDate,
            title,
            recurring: recurringWeekly ? 'weekly' : null,
            checkoutType,
        });
    }

    static updatePlannedCheckout({childId, planId, startDate, endDate, title, recurringWeekly, checkoutType}) {
        return RESTClient.putAuthenticated(`v2/children/${childId}/plannedCheckout/${planId}`, {
            startDate,
            endDate,
            title,
            recurring: recurringWeekly ? 'weekly' : null,
            checkoutType,
        });
    }

    // The recurring date itself
    static removePlannedCheckout({childId, planId}) {
        return RESTClient.deleteAuthenticated(`v2/children/${childId}/plannedCheckout/${planId}`);
    }

    // A specific recurring date
    static removePlannedCheckoutDate({childId, planId, date}) {
        return RESTClient.deleteAuthenticated(`v2/children/${childId}/plannedCheckout/${planId}/${date}`);
    }

    static moveChildInstitution(childId, institutionId, startDate, includeObservations) {
        return RESTClient.postAuthenticatedObservable(`v2/children/${childId}/move`, {
            institutionId,
            startDate,
            includeObservations,
        });
    }

    static cancelMoveChildInstitution(childId) {
        return RESTClient.deleteAuthenticatedObservable(`v2/children/${childId}/move`);
    }
}
